import { type TaggerEntityType } from "../../../zodios/apiDefinitions/api/taggers";
import { type TagEntityType } from "../../../zodios/apiDefinitions/api/tags";
import { type TSelector } from "../../../i18n/types";

export type { TaggerEntityType };

// Pattern B: labels travel as `advertising`-namespace selectors, resolved via `t(...)`
// at the consumer (TaggingRules.tsx binds the `advertising` namespace).
export const TAGGER_ENTITY_TYPE_LABELS: Record<TaggerEntityType, TSelector> = {
  advertisement: ($) => $.advertising["Advertisement"],
  keyword: ($) => $.advertising["Keyword"],
  target: ($) => $.advertising["Target"],
  product: ($) => $.advertising["Product"],
};

export const TAGGER_ENTITY_TYPE_OPTIONS: { value: TaggerEntityType; label: TSelector }[] = (
  Object.keys(TAGGER_ENTITY_TYPE_LABELS) as TaggerEntityType[]
).map((value) => ({ value, label: TAGGER_ENTITY_TYPE_LABELS[value] }));

export const TAGGER_TO_TAG_ENTITY_TYPE: Record<TaggerEntityType, TagEntityType> = {
  advertisement: "ADVERTISEMENT",
  keyword: "KEYWORD-TARGET",
  target: "KEYWORD-TARGET",
  product: "PRODUCT",
};
